import React from 'react';
import './ModernBlocks.css';

const ProcessBlock = ({ data }) => {
  return (
    <section className="process-section">
      <div className="process-container">
        <div className="process-header">
          <h2 className="process-title">
            {data.title}
          </h2>
          <p className="process-subtitle">
            {data.subtitle}
          </p>
        </div>
        <div className="process-steps">
          {data.steps.map((step, index) => (
            <div key={index} className="process-step">
              <div className="process-number">
                {step.number}
              </div>
              <h3 className="process-step-title">
                {step.title}
              </h3>
              <p className="process-step-description">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessBlock; 